<template>
    <el-drawer size="1000px"
               :withHeader="false"
               :visible.sync="editVisible"
               :close-on-press-escape="false"
               :wrapperClosable="false"
               :before-close="handleClickClose">
        <div class="drawer_wrap">
            <div class="drawer_header">
                <h3 class="title">编辑公司</h3>
                <i class="el-icon-close" @click="handleClickClose"></i>
            </div>
            <div class="drawer_body">
                <el-form size="small"
                         ref="companyForm"
                         label-position="right"
                         label-width="100px"
                         v-loading="loading"
                         :model="companyForm"
                         :rules="companyFormRules">
                    <el-form-item label="公司名称" prop="name">
                        <el-input placeholder="请输入" v-model="companyForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="管理员名称" prop="name">
                        <el-input placeholder="请输入管理员名称" v-model="companyForm.admin_name"></el-input>
                    </el-form-item>
                    <el-form-item label="权限节点" prop="role_node">
                        <el-checkbox :indeterminate="isIndeterminate"
                                     v-model="checked_all"
                                     @change="handleCheckedAllChange">
                            全选
                        </el-checkbox>
                        <el-tree :data="role_node_list"
                                 show-checkbox
                                 node-key="id"
                                 ref="role_node_tree"
                                 highlight-current
                                 :props="{children: '_child',label: 'title'}"
                                 @check-change="handleTreeCheckChange">
                        </el-tree>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer_footer">
                <el-button size="small" @click="handleClickClose">取消</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">
                    确定
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>
<script>

    import {CompanyDetail, EditCompany, getRoleNode} from '@/api'

    export default {
        name: 'addMenu',
        props: {
            editVisible: {
                type: Boolean,
                default: false,
            },
            companyId: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                companyForm: {
                    company_id: '',
                    admin_role_id: '',
                    name: '',
                    admin_name: '',
                    role_node: []
                },
                companyFormRules: {
                    name: [{required: true, message: '请输入公司名称'}],
                    admin_name: [{required: true, message: '请输入管理员名称'}],
                    role_node: [{required: true, message: '请至少选择一个权限节点'}],
                },
                loading: false,
                btnDisabled: false,
                checked_all: false,
                role_node_list: [],
                role_node_list_length: 0,
            }
        },
        computed: {
            isIndeterminate() {
                return this.companyForm.role_node.length > 0 && this.companyForm.role_node.length < this.role_node_list_length
            }
        },
        mounted() {
            if (this.companyId !== 0) {
                this.loading = true
                this.getDetail()
            }
        },
        methods: {
            //获取详情
            getDetail() {
                CompanyDetail({
                    company_id: this.companyId
                }).then(res => {
                    if (res.code === 200) {
                        this.companyForm.company_id = res.data.company_id;
                        this.companyForm.admin_role_id = res.data.admin_role_id;
                        this.companyForm.admin_name = res.data.role_name;
                        this.companyForm.name = res.data.name;
                        this.companyForm.role_node = res.data.role_node;
                        this._getRoleNode()
                    } else {
                        this.loading = false
                    }
                })
            },

            _getRoleNode() {
                getRoleNode({}).then(res => {
                    if (res.code === 200) {
                        this.role_node_list = res.data
                        this.companyForm.role_node.forEach(item => {
                            if (this.role_node_list.findIndex(node => node.id === item) < 0) {
                                this.$nextTick(() => {
                                    this.$refs.role_node_tree.setChecked(item, true)
                                })
                            } else {
                                this.$refs.role_node_tree.setChecked(item, true,false)
                            }
                        })
                        this.role_node_list_length = 0
                        this.getRoleNodeListLength(this.role_node_list)
                        if (this.companyForm.role_node.length === this.role_node_list_length) {
                            this.checked_all = true
                        }
                    }
                    this.loading = false
                })
            },

            handleCheckedAllChange(val) {
                this.role_node_list.forEach(node => {
                    this.$refs.role_node_tree.setChecked(node.id, val, true)
                })
                if (val) {
                    this.companyForm.role_node = []
                    this.getCheckedNodesId(this.role_node_list)
                } else {
                    this.companyForm.role_node = []
                }
            },

            getRoleNodeListLength(arr) {
                this.role_node_list_length += arr.length
                arr.forEach(node => {
                    if (node._child && node._child.length > 0) {
                        this.getRoleNodeListLength(node._child)
                    }
                })
            },

            getCheckedNodesId(arr) {
                arr.forEach(node => {
                    this.companyForm.role_node.push(node.id)
                    if (node._child && node._child.length) {
                        this.getCheckedNodesId(node._child)
                    }
                })
            },

            handleTreeCheckChange() {
                this.companyForm.role_node = this.$refs.role_node_tree.getHalfCheckedKeys().concat(this.$refs.role_node_tree.getCheckedKeys())
                this.role_node_list_length = 0
                this.getRoleNodeListLength(this.role_node_list)
                if (this.companyForm.role_node.length === this.role_node_list_length) {
                    this.checked_all = true
                }
            },

            //取消事件
            handleClickClose() {
                //重置表格
                this.$refs.companyForm.resetFields()
                //关闭对话框
                this.$emit('update:editVisible', false)
            },

            //确定事件
            handleClickConfirm() {
                this.$refs.companyForm.validate(valid => {
                    if (valid) {
                        EditCompany({
                            name: this.companyForm.name,
                            company_id: this.companyForm.company_id,
                            admin_name: this.companyForm.admin_name,
                            role_node: this.companyForm.role_node,
                        }).then(res => {
                            if (res.code === 200) {
                                // 验证通过调用新增菜单接口
                                this.$message.success('编辑成功')
                                //调用取消事件
                                this.handleClickClose()
                                //父页面刷新列表
                                this.$emit('success')
                            }else{
                              this.$message.error(res.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
        },

    }
</script>
<style lang="scss" scoped>

</style>
